/**
 * Creates a new object without the specified keys
 * @param {Object} obj - The original object
 * @param {Array} keysToExclude - Array of keys to exclude from the new object
 * @returns {Object} A new object without the excluded keys
 */
const excludeKeys = (obj, keysToExclude) => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  if (!Array.isArray(keysToExclude)) {
    return obj
  }

  return Object.keys(obj).reduce((newObj, key) => {
    if (!keysToExclude.includes(key)) {
      newObj[key] = obj[key]
    }
    return newObj
  }, {})
}

export default excludeKeys
